import { createContext, useContext, useRef } from 'react';

const FilterContext = createContext(null);

export function FilterProvider({ children }) {
  const storeRef = useRef({});

  const value = {
    get: (key) => storeRef.current[key] ?? null,
    set: (key, data) => { storeRef.current[key] = data; },
    clear: (key) => { delete storeRef.current[key]; },
    clearAll: () => { storeRef.current = {}; }
  };

  return (
    <FilterContext.Provider value={value}>
      {children}
    </FilterContext.Provider>
  );
}

export const useFilterContext = () => {
  const ctx = useContext(FilterContext);
  if (!ctx) throw new Error('useFilterContext must be inside FilterProvider');
  return ctx;
};
